import React, { Suspense, useState, useEffect } from 'react'
import { HashRouter, Navigate, Route, Routes } from 'react-router-dom'
import feathers from './services/feathers'
import './scss/style.scss'
import { useAuth0 } from '@auth0/auth0-react'
import { useDispatch } from 'react-redux'
import swal from 'sweetalert'
import { isEmpty, size } from 'lodash'
import Invitation from './views/invitation/Invitation'
import { generateUUID } from './utils/actions/ActionsGeneral'
import axios from 'axios'
const loading = (
  <div className="pt-3 text-center">
    <div className="sk-spinner sk-spinner-pulse"></div>
  </div>
)

const DefaultLayout = React.lazy(() => import('./layout/DefaultLayout'))

let App = () => {
  const { isLoading, loginWithRedirect, isAuthenticated, user, getAccessTokenSilently, logout } =
    useAuth0()
  const [logged, setLogged] = useState(false)
  const [userLogged, setUserLogged] = useState(null)
  const dispatch = useDispatch()
  const setUser = (state) => dispatch({ type: 'set', user: state })

  useEffect(() => {
    console.log('invitationXtranstec', localStorage.getItem('invitationXtranstec'))
    if (!isEmpty(localStorage.getItem('invitationXtranstec'))) {
      getInvitation()
    }
    // eslint-disable-next-line
  }, [user])

  useEffect(() => {
    const init = async () => {
      // await start()
      const publicPaths = ['/api-documentation', '/document-status']
      if (window.location.pathname.indexOf('/invitation/') !== -1) {
        localStorage.setItem('invitation', window.location.pathname)
      }
      if (!publicPaths.includes(window.location.pathname)) await start()
    }
    init()
    // eslint-disable-next-line
  }, [isLoading, getAccessTokenSilently, isAuthenticated, logged, loginWithRedirect, user])

  const getInvitation = async () => {
    try {
      await feathers
        .service('invitations')
        .find({
          query: {
            idInvitation: localStorage.getItem('invitationXtranstec'),
            used: 0,
          },
        })
        .then(function (res) {
          console.log('********')
          console.log('INVITACION', res)
          console.log('********')
          getUser(res[0])
        })
    } catch (error) {
      console.log('********')
      console.log(error)
      console.log('********')
    }
  }

  const getUser = async (data) => {
    await feathers
      .service('users')
      .find({
        query: {
          email: data.email,
        },
      })
      .then(async function (res) {
        console.log('********')
        console.log('USUARIO', res)
        console.log(data)
        console.log('********')

        if (size(res) > 0) {
          if (['sysadmin', 'support', 'superadmin'].includes(data.role)) {
            await feathers
              .service('users')
              .patch(res[0]._id, {
                role: data.role,
              })
              .then(function (res) {
                updateUseInvitation(data)
              })
              .catch(function (error) {
                console.log(error)
              })
          } else {
            updateRoleUser(res[0], data)
          }
        }
      })
      .catch(function (err) {
        console.log(err)
      })
  }

  const updateRoleUser = async (dataUser, data) => {
    let newOrganization = {
      customerName: data?.customerName,
      idCustomer: data?.organizationId,
      role: data?.role,
      active: true,
      id: generateUUID(),
    }
    let currenteOrganization = dataUser?.organizations.filter(
      (res) => res.idCustomer === data?.organizationId,
    )

    if (size(currenteOrganization) > 0) {
      updateUseInvitation(data)
    } else {
      await feathers
        .service('users')
        .patch(dataUser?._id, {
          organizations:
            size(dataUser.organizations) > 0
              ? dataUser?.organizations?.concat(newOrganization)
              : [newOrganization],
        })
        .then(function (res) {
          console.log('********')
          console.log('UPDATEUSER', res)
          console.log('********')
          updateUseInvitation(data)
        })
        .catch(function (error) {
          console.log(error)
        })
    }
  }

  const updateUseInvitation = async (data) => {
    await feathers
      .service('invitations')
      .patch(data._id, {
        used: 1,
      })
      .then(function (res) {
        console.log('********')
        console.log('UPDATEINVITATION', res)
        console.log('********')
        localStorage.setItem('invitationXtranstec', '')
        window.location.reload()
      })
      .catch(function (error) {
        console.log(error)
      })
  }

  const start = async () => {
    if (localStorage.getItem('feathers-jwt')) {
      setLogged(JSON.parse(localStorage.getItem('logged')))
      setUserLogged(JSON.parse(localStorage.getItem('user')))
      setUser(JSON.parse(localStorage.getItem('user')))
      // if (localStorage.invitation && window.location.pathname.indexOf('/invitation/') === -1) {
      //   window.location.href = `${window.location.origin}${localStorage.invitation}`
      // }
    }
    if (!logged) {
      if (!isAuthenticated && !isLoading && !logged) {
        let isInvited = localStorage.invitation ? true : false
        await loginWithRedirect({ signup: isInvited })
      } else if (isAuthenticated && !isLoading) {
        let resultToken = await setToken(user)
        let role = (resultToken && resultToken.user && resultToken.user.role) || null
        let newUser = {
          ...user,
          role: role,
          organizations: resultToken.user.organizations,
          modules: resultToken.user.modules || [],
        }

        localStorage.setItem('user', JSON.stringify(newUser))
        localStorage.setItem('logged', JSON.stringify(true))
        setUserLogged(newUser)
        setUser(newUser)
      }
    }
    if (!isLoading) {
      setTimeout(async () => {
        await checkToken()
      }, 0)
    }
  }

  const setToken = async (user) => {
    let token = await getAccessTokenSilently()
    localStorage.setItem('token', token)
    try {
      let userData = await feathers.authenticate({
        strategy: 'auth0',
        access_token: token,
      })
      return userData
    } catch (error) {
      console.error('App.js', error)
      await swal('Error', error.message, 'error')
      await logOut()
    }
  }

  const checkToken = async () => {
    if (localStorage.getItem('feathers-jwt') !== null) {
      await auth()
    } else {
      await loginWithRedirect({})
    }
  }

  const auth = async () => {
    try {
      await feathers.authenticate()
    } catch (error) {
      console.error('App.js', error)
      await logOut()
    }
  }
  const logOut = async () => {
    localStorage.removeItem('user')
    localStorage.removeItem('logged')
    localStorage.removeItem('token')
    try {
      await feathers.authentication.logout()
    } catch (error) {
      console.error('App.js', error)
      localStorage.removeItem('feathers-jwt')
    }
    await logout()
  }
  const [userRole, setUserRole] = useState('')
  const getDataUser = async () => {
    await axios
      .get(`${process.env.REACT_APP_URL_FEATHERS}/users?auth0Id=${user.sub}`)
      .then(function (response) {
        setUserRole(response.data[0])
      })
      .catch(function (error) {
        console.log(error)
      })
  }
  useEffect(() => {
    if (user) {
      getDataUser()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user])
  return (
    <HashRouter>
      <Suspense fallback={loading}>
        {userLogged ? (
          <Routes>
            <Route path="*" name="Home" element={<DefaultLayout logOut={logOut} {...user} />} />
            <Route path="/invitation/:key" name="Invitation" element={<Invitation />} />
            {userRole?.role === 'customer' && (
              <>
                <Route path="/users" name="Users" element={<Navigate to="/account-summary" />} />
                <Route
                  path="/customers"
                  name="Customers"
                  element={<Navigate to="/account-summary" />}
                />
                <Route
                  path="/customers/new-customer"
                  name="New Customer"
                  element={<Navigate to="/account-summary" />}
                />
                <Route
                  path="/account-receivable"
                  name="Account Receivable"
                  element={<Navigate to="/account-summary" />}
                />
                <Route
                  path="/account-receivable/new-invoice"
                  name="New Invoice"
                  element={<Navigate to="/account-summary" />}
                />
                <Route
                  path="/account-receivable/advance-payments"
                  name="Advance Payments"
                  element={<Navigate to="/account-summary" />}
                />
                <Route
                  path="/audit-log"
                  name="Audit Log"
                  element={<Navigate to="/account-summary" />}
                />
                <Route
                  path="/document-management"
                  name="Document Management"
                  element={<Navigate to="/account-summary" />}
                />
                <Route
                  path="/document-management/new-document/:id"
                  name="New Document"
                  element={<Navigate to="/account-summary" />}
                />
                <Route
                  path="/document-management/edit-document/:id"
                  name="Edit Document Management"
                  element={<Navigate to="/account-summary" />}
                />
                <Route
                  path="/operations/authorizations"
                  name="Shipments Authorization"
                  element={<Navigate to="/account-summary" />}
                />
                <Route
                  path="/operations/authorizations/edit-shipment-air/:id/:validAll"
                  name="Edit eCommerce Shipments (Air)"
                  element={<Navigate to="/account-summary" />}
                />
                <Route
                  path="/operations/authorizations/edit-shipment-ocean/:id/:validAll"
                  name="Edit eCommerce Shipments (Ocean)"
                  element={<Navigate to="/account-summary" />}
                />
                <Route
                  path="/operations/authorizations/edit-shipment-truck/:id"
                  name="Edit eCommerce Shipments (Truck)"
                  element={<Navigate to="/account-summary" />}
                />
              </>
            )}
          </Routes>
        ) : (
          <Routes>
            <Route path="*" name="Home" element={<DefaultLayout logOut={logOut} {...user} />} />
          </Routes>
        )}
      </Suspense>
    </HashRouter>
  )
}
export default App
